var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.isRecommendationsVisible
    ? _c("base-slider", {
        staticClass: "_py-3",
        attrs: {
          "is-processing": _vm.isProcessing,
          "medium-screen-visible-items-count":
            _vm.mediumScreenVisibleItemsCount,
          "large-screen-visible-items-count": _vm.largeScreenVisibleItemsCount,
          "extra-large-screen-visible-items-count":
            _vm.extraLargeScreenVisibleItemsCount,
          items: _vm.mappedRecommendedProducts,
          "slide-gap-classes": "_px-2 _px-3--m",
          "scroll-container-wrapper-classes": "_pos-r _-mx-2 _-mx-3--m",
          "data-qa": "product-recommendation-slider",
        },
        on: {
          "get-items": _vm.getProductRecommendations,
          "scroll-left": function ($event) {
            return _vm.onScroll("left")
          },
          "scroll-right": function ($event) {
            return _vm.onScroll("right")
          },
        },
        scopedSlots: _vm._u(
          [
            {
              key: "prefix",
              fn: function () {
                return [
                  _c("heading-with-icon", { attrs: { tag: "h3" } }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.Resources.YourPledge.YourPledgeRecommendationTitle
                        ) +
                        "\n        "
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "slide",
              fn: function ({ item }) {
                return [
                  _c("product-recommendation-item", {
                    attrs: {
                      item: item,
                      section: _vm.section,
                      "data-qa": `recommendation-item-number:${item.productID}`,
                    },
                    on: { "product-added": _vm.onProductAdded },
                  }),
                ]
              },
            },
            {
              key: "placeholder",
              fn: function () {
                return [_c("skeleton-product-recommendation-item")]
              },
              proxy: true,
            },
          ],
          null,
          false,
          364355512
        ),
      })
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }